module.exports = __webpack_public_path__ + "img/helpMaps1.cfd86676.png";